export default __webpack_public_path__ + "images/X3.a2c3e90.png";